// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__llMBL","col":"Table_col__1xQje","fulfillmentStatus":"Table_fulfillmentStatus__2EaCE","emailCol":"Table_emailCol__1xQ-g"};